import React from 'react';

import { Box, Skeleton, Typography } from '@mui/material';

import CompetitorOfferOpportunitiesTooltip from './CompetitorOfferOpportunitiesTooltip';
import { SELECTED_USER_LOCATION_SX, USER_LOCATION_CELL_COUNTRIES } from './constants';
import { CompetitorOfferRow, formatShare, hasGhaMatch, userLocationsFirst } from './utils';

interface Props {
  row: CompetitorOfferRow;
}

export default function CompetitorOfferUserLocationCell({ row }: Props) {
  const { gha, userLocations } = row;
  if (gha.status === 'loading' && hasGhaMatch(row)) {
    return <Skeleton width={140} />;
  }
  if (gha.status !== 'loaded' || !gha.opportunities?.opportunities) {
    return null;
  }
  const { opportunities } = gha;
  const countries = userLocationsFirst(opportunities.topCountries, userLocations);
  const selectedCount = countries.filter(
    (country) => country.countryCode && userLocations.includes(country.countryCode),
  ).length;

  return (
    <CompetitorOfferOpportunitiesTooltip
      hotelName={row.hotelName ?? row.externalPropertyId}
      opportunities={opportunities}
      userLocations={userLocations}
    >
      <Box display="flex" flexWrap="wrap" gap={0.5}>
        {countries.slice(0, Math.max(selectedCount, USER_LOCATION_CELL_COUNTRIES)).map((country, index) => {
          const selected = index < selectedCount;
          return (
            <Typography
              key={country.countryCode ?? 'unknown'}
              variant="body2"
              component="span"
              fontWeight={selected ? 'bold' : 'medium'}
              color={selected || !selectedCount ? 'text.primary' : 'text.secondary'}
              sx={selected ? { ...SELECTED_USER_LOCATION_SX, borderRadius: 0.5, px: 0.5 } : undefined}
            >
              {`${country.countryCode ?? 'Unknown'} ${formatShare(country.opportunities, opportunities.opportunities)}`}
            </Typography>
          );
        })}
      </Box>
    </CompetitorOfferOpportunitiesTooltip>
  );
}
